var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReset = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.833 3.333v5h5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.925 12.5A7.5 7.5 0 1 0 4.7 4.7L.833 8.333"
})));
SvgReset.viewBox = '0 0 20 20';
const ForwardRef = /*#__PURE__*/forwardRef(SvgReset);
export default ForwardRef;